"use client";
import React from "react";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { TurnrTableBody, TurnrTableSimple } from "~/components/table/TurnrTableSmart.jsx";
import ReportItemRow, { ItemRowTitleOrder, ItemRowTitleShipmentReturn } from "./ReportItemRow";
import { getReportedOrderItemId } from "~/cores/qualityCheckCore";

export default function ReportItemTable(props) {
    const { appProps, selectedOrder, returnOrShipmentRows, orderItems, itemFormValuesMap, setItemFormValues, highlightText, onRemoveOrderItem, children } = props;

    return (
        <TurnrGrid container spacing={2}>
            {returnOrShipmentRows?.map(({ orderReturn, shipment }) => {
                const items = shipment?.items || orderReturn?.items;

                if (!items?.length) {
                    return null;
                }

                return (
                    <TurnrGrid item xs={12} key={orderReturn?.id + "_" + shipment?.id}>
                        <TurnrCard>
                            <TurnrTableSimple>
                                <TurnrTableBody>
                                    <ItemRowTitleShipmentReturn appProps={appProps} orderReturn={orderReturn} shipment={shipment} highlightText={highlightText} />
                                    {items?.map((orderItem, index) => {
                                        return (
                                            <ReportItemRow
                                                key={getReportedOrderItemId(orderItem)}
                                                appProps={appProps}
                                                order={selectedOrder}
                                                orderItem={orderItem}
                                                highlightText={highlightText}
                                                formValues={itemFormValuesMap[getReportedOrderItemId(orderItem)]}
                                                setFormValues={(formValues) => setItemFormValues(orderItem, formValues)}
                                                style={index === items?.length - 1 ? { borderBottom: "none" } : undefined}
                                            />
                                        );
                                    })}
                                </TurnrTableBody>
                            </TurnrTableSimple>
                        </TurnrCard>
                    </TurnrGrid>
                );
            })}
            {(children || orderItems?.length > 0) && (
                <TurnrGrid item xs={12}>
                    <TurnrCard>
                        <TurnrTableSimple>
                            <TurnrTableBody>
                                {orderItems?.length > 0 && <ItemRowTitleOrder />}
                                {orderItems?.map((orderItem) => {
                                    return (
                                        <ReportItemRow
                                            key={getReportedOrderItemId(orderItem)}
                                            appProps={appProps}
                                            order={selectedOrder}
                                            orderItem={orderItem}
                                            highlightText={highlightText}
                                            formValues={itemFormValuesMap[getReportedOrderItemId(orderItem)]}
                                            setFormValues={(formValues) => setItemFormValues(orderItem, formValues)}
                                            onRemoveClick={onRemoveOrderItem && (() => onRemoveOrderItem(orderItem))}
                                        />
                                    );
                                })}
                                {children}
                            </TurnrTableBody>
                        </TurnrTableSimple>
                    </TurnrCard>
                </TurnrGrid>
            )}
        </TurnrGrid>
    );
}
